import { FieldPath } from '@form-ts/core';
import { useFormField } from '@form-ts/react';
import { pipe } from 'fp-ts/function';
import React, { useCallback } from 'react';
import { Switch } from 'src/modules/common/components/Switch';
import { FormError } from 'src/modules/form/types/FormError';

type Props<TData> = {
  readonly field: FieldPath<TData, FormError, boolean>;
  readonly disabled?: boolean;
  readonly title?: React.ReactNode;
  readonly valueActive?: React.ReactNode;
  readonly valueInactive?: React.ReactNode;
  readonly kind?: 'primary' | 'secondary';
  readonly readOnly?: boolean;
};

export const SwitchField: <TData>(props: Props<TData>) => React.ReactElement = ({
  field,
  disabled,
  title,
  valueActive,
  valueInactive,
  kind,
  readOnly,
}) => {
  const { value } = useFormField(field);

  const handleChange = useCallback(() => {
    field.form.change(pipe(
      field.form.currentState,
      field.value.set(!value),
    ));
  }, [field, value]);

  return (
    <Switch
      active={value}
      disabled={disabled}
      readOnly={readOnly}
      onChange={handleChange}
      title={title}
      valueActive={valueActive}
      valueInactive={valueInactive}
      kind={kind}
    />
  );
};
